import React, { SyntheticEvent, useEffect, useRef } from 'react';
import Editor from 'suneditor-react';
import font from 'suneditor/src/plugins/submenu/font';
import fontSize from 'suneditor/src/plugins/submenu/fontSize';
import formatBlock from 'suneditor/src/plugins/submenu/formatBlock';
import fontColor from 'suneditor/src/plugins/submenu/fontColor';
import hiliteColor from 'suneditor/src/plugins/submenu/hiliteColor';
import align from 'suneditor/src/plugins/submenu/align';
import horizontalRule from 'suneditor/src/plugins/submenu/horizontalRule';
import list from 'suneditor/src/plugins/submenu/list';
import lineHeight from 'suneditor/src/plugins/submenu/lineHeight';
import table from 'suneditor/src/plugins/submenu/table';
import link from 'suneditor/src/plugins/dialog/link';
import image from 'suneditor/src/plugins/dialog/image';
import template from 'suneditor/src/plugins/submenu/template';
import Resolution from './Plugins/Resolution';
import ActionItem from './Plugins/ActionItem';
import { WYSIWYGProps } from './WYSIWYG';
import { Alert, AlertTitle } from '@mui/material';
import axios, { AxiosRequestConfig } from 'axios';

import { useStore } from 'components/Content/Dashboard/Calendar/EditEvent/store';
import button from '../Button/Button';

export const differenceDays = (date_1: Date, date_2: Date) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
}

interface MinutesEditorProps {
    handleClick: (e: MouseEvent) => void,
    handleScroll: (e: Event) => void,
    parent_props: WYSIWYGProps,
    meetingId: number | string | undefined,
    minutesTakingButtonList: string | {
        name: string; idCommand: string; buttonClass: string;
        // HTML title attribute
        title: string;
        // 'submenu' or 'dialog' or '' (command button)
        idDisplay: string;
        // HTML to be append to button
        innerHTML: string;

    } | any
    fetchedActionItems: any[] | null | undefined
    setFetchedActionItems: React.Dispatch<React.SetStateAction<any[] | null | undefined>> | undefined

}

const MinutesEditor = React.memo(function CustomEditor({ handleClick, handleScroll, parent_props, meetingId, minutesTakingButtonList, fetchedActionItems, setFetchedActionItems }: MinutesEditorProps): JSX.Element {
    const wordCount = React.useRef<number>(0)
    const timeout = React.useRef<NodeJS.Timeout | null>(null)
    const alertOpen = React.useRef<boolean>(false);
    const [open, setOpen] = React.useState<boolean>(false)
    // @ts-expect-error
    const minutesRef = React.useRef<null | string>(parent_props.contentRef.current);
    const controllerRef = React.useRef<AbortController>(new AbortController());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [error, setError] = React.useState<boolean>(false)
    const savedRef = React.useRef<boolean>(false);
    // const addActionItemFn = useStore(state => state.addActionItemFn)
    // const deleteActionItemFn = useStore(state => state.deleteActionItemFn)
    const deletedAction = useStore(state => state.deletedAction)
    const addedAction = useStore(state => state.addedAction)
    const editorRef = useRef<any>(null); // Add this line

    React.useEffect(() => {
        // console.log(deletedAction, "DELETED ACTION")
        // console.log(addedAction, "ADDED ACTION")

    }, [deletedAction, addedAction])


    const handleCloseAlert = (e: SyntheticEvent | Event) => {
        setOpen(false)
    }



    React.useEffect(() => {
        // const controllerLocal = controllerRef.current
        return () => {
            setError(false)
            timeout.current && clearTimeout(timeout.current)
            // controllerLocal && controllerLocal.abort()
        }
    }, [alertOpen, meetingId])

    // React.useEffect(() => {
    //     console.log(JSON.parse(sessionStorage.getItem('actionItems') ?? ''), "ACTION ITEMS")
    // })

    // React.useEffect(() => {
    //     console.log(currentActionPoints, "CURRENT ACTION POINTS")
    //     console.log(previousActionPoints, "PREVIOUS ACTION POINTS")
    // },[previousActionPoints, currentActionPoints])

    const handleChange = React.useCallback((minutes: string) => {

        minutesRef.current = minutes
        // @ts-expect-error
        parent_props.contentRef.current = minutesRef.current
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parent_props.contentRef, meetingId, fetchedActionItems])

    const handleOnKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') return null;
        wordCount.current = wordCount.current + 1
        if (wordCount.current === 50) {
            setOpen(true)
            if (!open) {
                if (minutesRef.current && meetingId) {
                    setError(false)
                    axios.put(`/meetings/${meetingId}/minutes`, {
                        minutes: minutesRef.current
                    }, {
                        signal: controllerRef.current.signal
                    } as AxiosRequestConfig
                    ).then((res) => {
                        if (res.data.code)
                            timeout.current && clearTimeout(timeout.current)

                        timeout.current = setTimeout(() => {
                            setOpen(false)
                        }, 2000)
                    }).catch(() => {
                        setError(true)
                    })
                }
            }
            wordCount.current = 0
        }
    }
    const handleSave = (content: string, isChanged: boolean) => {
        if (isChanged) {
            savedRef.current = true
            setOpen(true);
            axios.put(`/meetings/${meetingId}/minutes`, {
                minutes: content
            }, {
                signal: controllerRef.current.signal
            } as AxiosRequestConfig
            ).then((res) => {
                timeout.current && clearTimeout(timeout.current)
                timeout.current = setTimeout(() => {
                    setOpen(false);
                    savedRef.current = false;
                    wordCount.current = 0
                }, 2000)
            }).catch(() => {
                setError(true)
            })
        }
    }

    // Call this function to insert HTML/text at the cursor
    const insertAtCursor = (html: string) => {
        if (editorRef.current) {
            editorRef.current.insertHTML(html);
        }
    };

    // Optionally, expose this function to parent via ref or callback
    React.useEffect(() => {
        if (typeof parent_props.contentRef === "object" && parent_props.contentRef) {
            // @ts-ignore
            parent_props.contentRef.current = {
                ...(typeof parent_props.contentRef.current === 'object' && parent_props.contentRef.current !== null
                    ? parent_props.contentRef.current
                    : {}),
                insertAtCursor,
            };
        }
    }, [parent_props.contentRef]);

    return (
        <>
            <Alert severity="success"
                onClose={handleCloseAlert}
                sx={{
                    transition: 'all 1s',
                    display: open ? 'flex' : 'none',
                    position: "absolute",
                    zIndex: 10,
                    bottom: 0,
                    right: '50%',
                }}>
                <AlertTitle>Auto Saved</AlertTitle>
                {/* This is a success alert — <strong>check it out!</strong> */}
            </Alert>

            <Editor
                lang="en"
                autoFocus={true}
                onClick={handleClick}
                onKeyDown={(e) => handleOnKeyDown(e)}
                onScroll={handleScroll}
                setOptions={{
                    height: parent_props.height ?? '540px',
                    plugins: [font, fontSize, formatBlock, fontColor, hiliteColor, align, horizontalRule, list, lineHeight, table, link, image, template, Resolution, ActionItem],
                    buttonList: minutesTakingButtonList,
                    templates: [parent_props.minutesTemplate],
                    showPathLabel: false,
                    charCounter: true,
                    width: "100%",
                    callBackSave: (content: string, isChanged: boolean) => handleSave(content, isChanged)
                }}
                // @ts-expect-error
                setContents={parent_props.contentRef ? parent_props.contentRef.current : parent_props.content}
                onChange={handleChange}
                onLoad={(instance) => {
                    editorRef.current = instance;
                }}
            />
        </>
    )
})
export default MinutesEditor;

